module.exports = __webpack_public_path__ + "static/media/insurance.5eaeafbc.png";